import {prepareContentTypeImage} from './prepareContentTypeImage';
import {prepareFileFromBlob} from './prepareFileFromBlob';

export const getInstrumentLogo = (data: any) => {
  const contentType = prepareContentTypeImage(data?.extention);
  return prepareFileFromBlob(data?.byteArray, contentType, data?.fileName);
};
